<!--
  面板容器，用于展示块信息

  <lc-panel :title="标题" :loading="loading">
    <template slot="extra">
      ...这里按钮
    </template>

    ...内容
  </lc-panel>
 -->
<template>
  <div class="lc-panel" :style="panelStyle">
    <!-- 头部-->
    <div v-if="!isEmptyObject(title) || titleSlotContentExists" class="panel-header">
      <span class="panel-title">{{ title }}<slot name="title"></slot></span>

      <div class="pull-right"><slot name="extra"></slot></div>

      <div v-if="headerBottomBorder" class="title-underline"></div>
    </div>

    <!-- 内容 -->
    <el-skeleton :count="1" :loading="loading">
      <div class="panel-body">
        <slot></slot>
      </div>
    </el-skeleton>
  </div>
</template>

<script>
export default {
  props: {
    // 标题
    title: {
      type: String,
      default: ''
    },
    // 宽度，如100%, 100, 100px
    width: {
      type: [Number, String],
      default: ''
    },
    /**
     * 需要加载中的效果
     */
    loading: {
      type: Boolean,
      default: false
    },
    /**
     * 是否显示头部的底边
     */
    headerBottomBorder: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    /**
     * 面板的样式
     *
     * @returns {object} 样式对象
     */
    panelStyle() {
      let widthValue = isNaN(this.width) ? this.width : `${this.width}px`
      return { width: widthValue }
    },
    titleSlotContentExists() {
      return this.$slots.title != null
    }
  }
}
</script>

<style lang="scss" scoped>
// Panel
.lc-panel {
  background-color: #fff;
  padding: 15px;
  border-radius: 4px;
  margin-bottom: 10px;
  height: 100%;

  .panel-header {
    margin-bottom: 20px;

    .panel-title {
      font-size: 16px;
      font-weight: 600;
    }
  }
  .title-underline {
    height: 1px;
    background-color: #ebeef5;
    margin-top: 10px;
  }
  // 解决刷新后不生效
  ::v-deep .panel-body {
    padding: 0px 5px;
  }
}
</style>
